"use strict!"
import Waves from 'node-waves';
export function ableProHorizontal(){
  window["is_chrome"] = null;
  window["is_explorer"] = null;
  window["is_firefox"] = null;
  window["is_safari"] = null;
  window["is_opera"] = null;
  window["is_mac"] = null;
  window["is_windows"] = null;
  window["tw"] = null;
  window["dt"] = null;
	// variable
  var noofdays = 1;                       //  total no of days cookie will store
  var Navbarbg = "themelight1";           //  navbar color                themelight1 / theme1
  var headerbg = "theme4";                //  header color                theme1 / theme2 / theme3 / theme4 / theme5 / theme6
  var menucaption = "theme4";             //  menu caption color          theme1 / theme2 / theme3 / theme4 / theme5 / theme6 / theme7 / theme8 / theme9
  var bgpattern = "theme4";               //  background color            theme1 / theme2 / theme3 / theme4 / theme5 / theme6
  var activeitemtheme = "theme4";         //  menu active color           theme1 / theme2 / theme3 / theme4 / theme5 / theme6 / theme7 / theme8 / theme9 / theme10 / theme11 / theme12
  var frametype = "theme4";               //  preset frame color          theme1 / theme2 / theme3 / theme4 / theme5 / theme6
  var layout_type = "light";              //  theme layout color          dark / light
  var layout_width = "wide";              //  theme layout size           wide / box
  var menu_effect_desktop = "shrink";     //  navbar effect in desktop    shrink / overlay / push
  var menu_effect_tablet = "overlay";     //  navbar effect in tablet     shrink / overlay / push
  var menu_effect_phone = "overlay";      //  navbar effect in phone      shrink / overlay / push
  var menu_icon_style = "st2";            //  navbar menu icon            st1 / st2
  function setCookie(cname, cvalue, exdays) {
	var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      // var expires = "expires=" + d.toGMTString();
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(noofdays);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  function checkCookie() {
      Navbarbg = (getCookie("NavbarBackground") != "") ? getCookie("NavbarBackground"): Navbarbg;
      headerbg = (getCookie("header-theme") != "") ? getCookie("header-theme"): headerbg;
      menucaption = (getCookie("menu-title-theme") != "") ? getCookie("menu-title-theme"): menucaption;
      bgpattern = (getCookie("themebg-pattern") != "") ? getCookie("themebg-pattern"): bgpattern;
      activeitemtheme = (getCookie("active-item-theme") != "") ? getCookie("active-item-theme"): activeitemtheme;
      frametype = (getCookie("fream-type") != "") ? getCookie("fream-type"): frametype;
      layout_type = (getCookie("layoutlayout") != "") ? getCookie("layoutlayout"): layout_type;
      layout_width = (getCookie("vertical-layout") != "") ? getCookie("vertical-layout"): layout_width;
      menu_effect_desktop = (getCookie("vertical-effect") != "") ? getCookie("vertical-effect"): menu_effect_desktop;
      menu_icon_style = (getCookie("menu-icon-style") != "") ? getCookie("menu-icon-style"): menu_icon_style;
  }
  checkCookie();
	$('.pcoded-navbar .pcoded-hasmenu').attr('subitem-icon', 'style1');
	$( "#pcoded" ).pcodedmenu({
		themelayout: 'horizontal',
		horizontalMenuplacement: 'top',
		horizontalBrandItem: true,
		horizontalLeftNavItem: true,
		horizontalRightItem: true,
		horizontalSearchItem: true,
		horizontalMobileMenu: true,
		MenuTrigger: 'hover',
		SubMenuTrigger: 'hover',
		activeMenuClass: 'active',
		ThemeBackgroundPattern: bgpattern,
		HeaderBackground: headerbg,
    LHeaderBackground: menucaption,
		NavbarBackground: Navbarbg,
		ActiveItemBackground: activeitemtheme,
		SubItemBackground: 'theme2',
		menutype: menu_icon_style,
    freamtype: frametype,
		layouttype: layout_type,
		ActiveItemStyle: 'style1',
		ItemBorder: true,
		ItemBorderStyle: 'none',
		SubItemBorder: true,
		DropDownIconStyle: 'style1',
		FixedNavbarPosition: false,
		FixedHeaderPosition: false,
		horizontalNavIsCentered: false,
		horizontalstickynavigation: false,
		horizontalNavigationMenuIcon: true,
	});
	/* layout type Change function Start */
    function handlelayouttheme() {
        $('.theme-color > a.Layout-type').on("click", function() {
            var layout = $(this).attr("layout-type");
            $('.pcoded').attr("layout-type", layout);
            setCookie("layoutlayout", layout, noofdays);
            if (layout == 'dark') {
                $('.pcoded-header').attr("header-theme", "theme2");
                $('.pcoded-navbar').attr("navbar-theme", "theme4");
                $('.pcoded-navbar').attr("active-item-theme", "theme2");
                $('.pcoded').attr("fream-type", "theme2");
                $('body').addClass('dark');
                $('body').attr("themebg-pattern", "theme2");
                $('.pcoded-navigation-label').attr("menu-title-theme", "theme9");
                setCookie("header-theme", "theme2", noofdays);
                setCookie("NavbarBackground", "theme4", noofdays);
                setCookie("menu-title-theme", "theme9", noofdays);
                setCookie("themebg-pattern", "theme2", noofdays);
                setCookie("fream-type", "theme2", noofdays);
                setCookie("active-item-theme", "theme2", noofdays);
            }
            if (layout == 'light') {
                $('.pcoded-header').attr("header-theme", "theme4");
                $('.pcoded-navbar').attr("navbar-theme", "themelight1");
                $('.pcoded-navigation-label').attr("menu-title-theme", "theme4");
                $('.pcoded-navbar').attr("active-item-theme", "theme4");
                $('.pcoded').attr("fream-type", "theme4");
                $('body').removeClass('dark');
                $('body').attr("themebg-pattern", "theme4");
                setCookie("header-theme", "theme4", noofdays);
                setCookie("NavbarBackground", "themelight1", noofdays);
                setCookie("menu-title-theme", "theme4", noofdays);
                setCookie("themebg-pattern", "theme4", noofdays);
                setCookie("fream-type", "theme4", noofdays);
                setCookie("active-item-theme", "theme4", noofdays);
            }
            if (layout == 'reset') {
                setCookie("NavbarBackground", null, 0);
                setCookie("header-theme", null, 0);
                setCookie("menu-title-theme", null, 0);
                setCookie("themebg-pattern", null, 0);
                setCookie("active-item-theme", null, 0);
                setCookie("fream-type", null, 0);
                setCookie("layoutlayout", null, 0);
                setCookie("vertical-layout", null, 0);
                setCookie("vertical-effect", null, 0);
                location.reload();
            }
        });
    };
    handlelayouttheme();

    /* Left header Theme Change function Start */
    function handleleftheadertheme() {
        $('.theme-color > a.leftheader-theme').on("click", function() {
            var lheadertheme = $(this).attr("menu-caption");
            $('.pcoded-navigation-label').attr("menu-title-theme", lheadertheme);
            setCookie("menu-title-theme", lheadertheme, noofdays);
        });
    };
    handleleftheadertheme();
    /* Left header Theme Change function Close */
    /* header Theme Change function Start */
    function handleheadertheme() {
        $('.theme-color > a.header-theme').on("click", function() {
            var headertheme = $(this).attr("header-theme");
            var activeitem = $(this).attr("active-item-color");
            $('.pcoded-header').attr("header-theme", headertheme);
            $('.pcoded-navbar').attr("active-item-theme", activeitem);
            $('.pcoded').attr("fream-type", headertheme);
            $('.pcoded-navigation-label').attr("menu-title-theme", headertheme);
            $('body').attr("themebg-pattern", headertheme);

            // coockies
            setCookie("header-theme", headertheme, noofdays);
            setCookie("active-item-theme", activeitem, noofdays);
            setCookie("menu-title-theme", headertheme, noofdays);
            setCookie("themebg-pattern", headertheme, noofdays);
            setCookie("fream-type", headertheme, noofdays);
        });
    };
    handleheadertheme();
    /* header Theme Change function Close */
    /* Navbar Theme Change function Start */
    function handlenavbartheme() {
        $('.theme-color > a.navbar-theme').on("click", function() {
            var navbartheme = $(this).attr("navbar-theme");
            $('.pcoded-navbar').attr("navbar-theme", navbartheme);
            setCookie("NavbarBackground", navbartheme, noofdays);
            if (navbartheme == 'themelight1') {
                $('.pcoded-navigation-label').attr("menu-title-theme", "theme4");
                setCookie("menu-title-theme", "theme4", noofdays);
            }
            if (navbartheme == 'theme1') {
                $('.pcoded-navigation-label').attr("menu-title-theme", "theme9");
                setCookie("menu-title-theme", "theme9", noofdays);
            }
        });
    };

    handlenavbartheme();
    /* Navbar Theme Change function Close */
    /* Active Item Theme Change function Start */
    function handleactiveitemtheme() {
        $('.theme-color > a.active-item-theme').on("click", function() {
            var activeitemtheme = $(this).attr("active-item-theme");
            $('.pcoded-navbar').attr("active-item-theme", activeitemtheme);
            setCookie("active-item-theme", activeitemtheme, noofdays);
        });
    };

    handleactiveitemtheme();
    /* Active Item Theme Change function Close */

    /* Theme background pattren Change function Start */
    function handlethemebgpattern() {
        $('.theme-color > a.themebg-pattern').on("click", function() {
            var themebgpattern = $(this).attr("themebg-pattern");
            $('body').attr("themebg-pattern", themebgpattern);
            setCookie("themebg-pattern", themebgpattern, noofdays);
        });
    };

    handlethemebgpattern();
    /* Theme background pattren Change function Close */

    /* Theme Layout Change function start*/
    function handlethemeverticallayout() {
        $('#theme-layout').change(function() {
            if ($(this).is(":checked")) {
                $('.pcoded').attr('vertical-layout', "box");
                setCookie("vertical-layout", "box", noofdays);
                $('#bg-pattern-visiblity').removeClass('d-none');

            } else {
                $('.pcoded').attr('vertical-layout', "wide");
                setCookie("vertical-layout", "wide", noofdays);
                $('#bg-pattern-visiblity').addClass('d-none');
            }
        });
    };
    handlethemeverticallayout();
    /* Theme Layout Change function Close*/
    /* Menu effect change function start*/
    function handleverticalMenueffect() {
        $('#vertical-menu-effect').val('shrink').on('change', function() {
            let get_value: string = <string>$(this).val();
            $('.pcoded').attr('vertical-effect', get_value);
            setCookie("vertical-effect", get_value, noofdays);
        });
    };

    handleverticalMenueffect();
    /* Menu effect change function Close*/

    /* Vertical Item border Style change function Start*/
    function handleverticalboderstyle() {
        $('#vertical-border-style').val('solid').on('change', function() {
          let get_value: string = <string>$(this).val();
            $('.pcoded-navbar .pcoded-item').attr('item-border-style', get_value);
        });
    };

    handleverticalboderstyle();
    /* Vertical Item border Style change function Close*/

    /* Vertical Dropdown Icon change function Start*/
    function handleVerticalDropDownIconStyle() {
        $('#vertical-dropdown-icon').val('style1').on('change', function() {
          let get_value: string = <string>$(this).val();
            $('.pcoded-navbar .pcoded-hasmenu').attr('dropdown-icon', get_value);
        });
    };

    handleVerticalDropDownIconStyle();
    /* Vertical Dropdown Icon change function Close*/
    /* Vertical SubItem Icon change function Start*/

    function handleVerticalSubMenuItemIconStyle() {
        $('#vertical-subitem-icon').val('style5').on('change', function() {
          let get_value: string = <string>$(this).val();
            $('.pcoded-navbar .pcoded-hasmenu').attr('subitem-icon', get_value);
        });
    };

    handleVerticalSubMenuItemIconStyle();
    /* Vertical SubItem Icon change function Close*/
    /* Vertical Navbar Position change function Start*/
    function handlesidebarposition() {
        $('#sidebar-position').change(function() {
            if ($(this).is(":checked")) {
                $('.pcoded-navbar').attr("pcoded-navbar-position", 'fixed');
                $('.pcoded-header .pcoded-left-header').attr("pcoded-lheader-position", 'fixed');
            } else {
                $('.pcoded-navbar').attr("pcoded-navbar-position", 'absolute');
                $('.pcoded-header .pcoded-left-header').attr("pcoded-lheader-position", 'relative');
            }
        });
    };

    handlesidebarposition();
    /* Vertical Navbar Position change function Close*/
    /* Vertical Header Position change function Start*/
    function handleheaderposition() {
        $('#header-position').change(function() {
            if ($(this).is(":checked")) {
                $('.pcoded-header').attr("pcoded-header-position", 'fixed');
                $('.pcoded-navbar').attr("pcoded-header-position", 'fixed');
                $('.pcoded-main-container').css('margin-top', $(".pcoded-header").outerHeight());
            } else {
                $('.pcoded-header').attr("pcoded-header-position", 'relative');
                $('.pcoded-navbar').attr("pcoded-header-position", 'relative');
                $('.pcoded-main-container').css('margin-top', '0px');
            }
        });
    };
    handleheaderposition();
    /* Vertical Header Position change function Close*/
    /*  collapseable Left Header Change Function Start here*/
    function handlecollapseLeftHeader() {
        $('#collapse-left-header').change(function() {
            if ($(this).is(":checked")) {
                $('.pcoded-header, .pcoded ').removeClass('iscollapsed');
                $('.pcoded-header, .pcoded').addClass('nocollapsed');
            } else {
                $('.pcoded-header, .pcoded').addClass('iscollapsed');
                $('.pcoded-header, .pcoded').removeClass('nocollapsed');
            }
        });
    };
    handlecollapseLeftHeader();
    /*  collapseable Left Header Change Function Close here*/
    function handlemenutype(get_value) {
        $('.pcoded').attr('nav-type', get_value);
        setCookie("menu-icon-style", get_value, noofdays);
    };

    handlemenutype("st2");
    scripts();
};

// copied from able-pro/files/assets/js/script.js
function scripts(){
    var $win = $(window),
        $main = $('main'),
        $nav = $('.pcoded-navbar'),
        navHeight = $nav.outerHeight(),
        navPos = $nav.offset().top,
        fixedClass = 'is-fixed';
    //
    $win.on('load scroll', function() {
      var value = $(this).scrollTop();
      if ( value > navPos + 10 ) {
        $nav.addClass(fixedClass);
        $main.css('margin-top', navHeight);
      } else {
        $nav.removeClass(fixedClass);
        $main.css('margin-top', '0');
      }
    });
    // });
    // $(".card-header-right .close-card").on('click', function() {
    //     var $this = $(this);
    //     $this.parents('.card').animate({
    //         'opacity': '0',
    //         '-webkit-transform': 'scale3d(.3, .3, .3)',
    //         'transform': 'scale3d(.3, .3, .3)'
    //     });
    //
    //     setTimeout(function() {
    //         $this.parents('.card').remove();
    //     }, 800);
    // });
    // $(".card-header-right .reload-card").on('click', function() {
    //     var $this = $(this);
    //     $this.parents('.card').addClass("card-load");
    //     $this.parents('.card').append('<div class="card-loader"><i class="feather icon-radio rotate-refresh"></div>');
    //     setTimeout(function() {
    //         $this.parents('.card').children(".card-loader").remove();
    //         $this.parents('.card').removeClass("card-load");
    //     }, 3000);
    // });
    // $(".card-header-right .card-option .open-card-option").on('click', function() {
    //     var $this = $(this);
    //     if ($this.hasClass('icon-x')) {
    //         $this.parents('.card-option').animate({
    //             'width': '30px',
    //         });
    //         $(".open-card-option").removeClass("icon-x").fadeIn('slow');
    //         $(".open-card-option").addClass("icon-chevron-left").fadeIn('slow');
    //         $this.parents('.card-option').children(".first-opt").fadeIn();
    //     } else {
    //         $this.parents('.card-option').animate({
    //             'width': '130px',
    //         });
    //         $(".open-card-option").addClass("icon-x").fadeIn('slow');
    //         $(".open-card-option").removeClass("icon-chevron-left").fadeIn('slow');
    //         $this.parents('.card-option').children(".first-opt").fadeOut();
    //     }
    // });
    // $(".card-header-right .minimize-card").on('click', function() {
    //     var $this = $(this);
    //     var port = $($this.parents('.card'));
    //     var card = $(port).children('.card-block').slideToggle();
    //     $(this).toggleClass("icon-minus").fadeIn('slow');
    //     $(this).toggleClass("icon-plus").fadeIn('slow');
    // });
    // $(".card-header-right .full-card").on('click', function() {
    //     var $this = $(this);
    //     var port = $($this.parents('.card'));
    //     port.toggleClass("full-card");
    //     $(this).toggleClass("icon-minimize");
    //     $(this).toggleClass("icon-maximize");
    // });
    // $("#more-details").on('click', function() {
    //     $(".more-details").slideToggle(500);
    // });
    // $(".mobile-options").on('click', function() {
    //     $(".navbar-container .nav-right").slideToggle('slow');
    // });
    // $(".search-btn").on('click', function() {
    //     $(".main-search").addClass('open');
    //     $('.main-search .form-control').animate({
    //         'width': '200px',
    //     });
    // });
    // $(".search-close").on('click', function() {
    //     $('.main-search .form-control').animate({
    //         'width': '0',
    //     });
    //     setTimeout(function() {
    //         $(".main-search").removeClass('open');
    //     }, 300);
    // });
    // // card js end
    // // $.mCustomScrollbar.defaults.axis = "yx";
    // $("#styleSelector .style-cont").slimScroll({
    //     setTop: "1px",
    //     height: "calc(100vh - 520px)",
    // });
    //
    // /*chatbar js start*/
    // /*chat box scroll*/
    // var a = $(window).height() - 80;
    // $(".main-friend-list").slimScroll({
    //     height: a,
    //     allowPageScroll: false,
    //     wheelStep: 5
    // });
    // var a = $(window).height() - 155;
    // $(".main-friend-chat").slimScroll({
    //     height: a,
    //     allowPageScroll: false,
    //     wheelStep: 5
    // });
    //
    // // search
    // $("#search-friends").on("keyup", function() {
    //     var g = $(this).val().toLowerCase();
    //     $(".userlist-box .media-body .chat-header").each(function() {
    //         var s = $(this).text().toLowerCase();
    //         $(this).closest('.userlist-box')[s.indexOf(g) !== -1 ? 'show' : 'hide']();
    //     });
    // });
    //
    // // open chat box
    // $('.displayChatbox').on('click', function() {
    //     var my_val = $('.pcoded').attr('vertical-placement');
    //     if (my_val == 'right') {
    //         var options = {
    //             direction: 'left'
    //         };
    //     } else {
    //         var options = {
    //             direction: 'right'
    //         };
    //     }
    //     $('.showChat').toggle('slide', options, 500);
    // });
    //
    // //open friend chat
    // $('.userlist-box').on('click', function() {
    //     var my_val = $('.pcoded').attr('vertical-placement');
    //     if (my_val == 'right') {
    //         var options = {
    //             direction: 'left'
    //         };
    //     } else {
    //         var options = {
    //             direction: 'right'
    //         };
    //     }
    //     $('.showChat_inner').toggle('slide', options, 500);
    // });
    // //back to main chatbar
    // $('.back_chatBox').on('click', function() {
    //     var my_val = $('.pcoded').attr('vertical-placement');
    //     if (my_val == 'right') {
    //         var options = {
    //             direction: 'left'
    //         };
    //     } else {
    //         var options = {
    //             direction: 'right'
    //         };
    //     }
    //     $('.showChat_inner').toggle('slide', options, 500);
    //     $('.showChat').css('display', 'block');
    // });
    // $('.back_friendlist').on('click', function() {
    //     var my_val = $('.pcoded').attr('vertical-placement');
    //     if (my_val == 'right') {
    //         var options = {
    //             direction: 'left'
    //         };
    //     } else {
    //         var options = {
    //             direction: 'right'
    //         };
    //     }
    //     $('.p-chat-user').toggle('slide', options, 500);
    //     $('.showChat').css('display', 'block');
    // });
    // /*chatbar js end*/

  $('[data-toggle="tooltip"]').tooltip();

  // wave effect js
  Waves.init();
  Waves.attach('.flat-buttons', ['waves-button']);
  Waves.attach('.float-buttons', ['waves-button', 'waves-float']);
  Waves.attach('.float-button-light', ['waves-button', 'waves-float', 'waves-light']);
  Waves.attach('.flat-buttons', ['waves-button', 'waves-float', 'waves-light', 'flat-buttons']);

  $('#mobile-collapse i').addClass('icon-toggle-right');
  $('#mobile-collapse').on('click', function() {
      $('#mobile-collapse i').toggleClass('icon-toggle-right');
      $('#mobile-collapse i').toggleClass('icon-toggle-left');
  });

}
